import classNames from "classnames";
import { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./css/Chip.module.css";

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  // solid: 선택 시 진한 배경(필터 버튼), outline: 선택 시 테두리 강조(드롭다운형 필터)
  selectedStyle?: "solid" | "outline";
}

export default function Chip({
  selected = false,
  leadingIcon,
  trailingIcon,
  selectedStyle = "solid",
  className,
  children,
  type = "button",
  ...rest
}: ChipProps) {
  return (
    <button
      type={type}
      aria-pressed={selected}
      className={classNames(
        styles.chip,
        {
          [styles.selectedSolid]: selected && selectedStyle === "solid",
          [styles.selectedOutline]: selected && selectedStyle === "outline",
        },
        className
      )}
      {...rest}
    >
      {leadingIcon && <span className={styles.icon}>{leadingIcon}</span>}
      <span>{children}</span>
      {trailingIcon && <span className={styles.icon}>{trailingIcon}</span>}
    </button>
  );
}
